export default __webpack_public_path__ + "static/triggered-spotlight-light-58292ef79440019f45ed0c97a63630ea81df5c444cbff5bca9bfa13c1aac5b76.png";